import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "../components/common/Seo";
import PageHeader from "../components/common/PageHeader";
import { RevealStagger, RevealItem } from "../components/common/Reveal";
import { insights, insightCategories } from "../lib/content";

export default function Insights() {
  return (
    <>
      <Seo
        title="Insights — Kratos Venture Group"
        description="Perspectives on business development, AI agents, automation, sales systems, operations, and technology strategy."
        path="/insights"
      />
      <PageHeader eyebrow="Insights" title="Perspectives on building intelligent businesses." intro="Practical thinking on systems, automation, and intelligent execution.">
        <div className="mt-8 flex flex-wrap gap-2">
          {insightCategories.map((c) => (
            <span key={c} className="font-mono text-[10px] uppercase tracking-[0.16em] text-kv-steel border border-kv-steel/25 px-3 py-1.5" data-testid={`insight-category-${c.toLowerCase().replace(/\s+/g, "-")}`}>{c}</span>
          ))}
        </div>
      </PageHeader>

      <section className="relative py-16 md:py-24" data-testid="insights-list">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <RevealStagger className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {insights.map((post) => (
              <RevealItem key={post.slug}>
                <Link
                  to={`/insights/${post.slug}`}
                  data-testid={`insight-card-${post.slug}`}
                  className="group flex flex-col justify-between h-full kv-card p-8 md:p-9 min-h-[280px]"
                >
                  <div>
                    <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-kv-royal mb-6">{post.category}</div>
                    <h2 className="font-display text-xl md:text-2xl font-medium tracking-tight text-kv-off leading-snug">{post.title}</h2>
                    <p className="mt-4 font-body text-sm text-kv-grey leading-relaxed">{post.excerpt}</p>
                  </div>
                  <div className="mt-8 flex items-center gap-2 font-mono text-[11px] uppercase tracking-wide text-kv-steel group-hover:text-kv-electric transition-colors">
                    Read outline <ArrowUpRight className="h-4 w-4" />
                  </div>
                </Link>
              </RevealItem>
            ))}
          </RevealStagger>
        </div>
      </section>
    </>
  );
}
